import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Col, Button } from 'antd';

const mapStateToProps = state => ({
    leadomatic: state.Leads.Lead_profile.Lead_general.leadomatic,
    ref_lead_source: state.Leads.Lead_profile.Lead_marketing.ref_lead_source,
});

export default connect(mapStateToProps, null)(class LeadomaticInfo extends Component {
    render() {
        const { leadomatic, ref_lead_source } = this.props;
        return (
            leadomatic && ref_lead_source && ref_lead_source._id === '5be93e5f683059f77dbcef4c'
                ? (
                    <Col span={24}>
                        <h3 className="header">Lead-O-Matic</h3>
                        <p style={{ width: '100%' }}>
                            <span style={{ width: '16%' }}>Description:</span>
                            <span style={{ width: '84%' }} className="value">{leadomatic.advert_description}</span>
                        </p>
                        <p>
                            <span>Title:</span>
                            <span className="value">{leadomatic.advert_title || '-'}</span>
                        </p>
                        <p>
                            <span>Price:</span>
                            <span className="value">
                                £
                                {leadomatic.advert_price || '-'}
                            </span>
                        </p>
                        <p>
                            <span>Original Price:</span>
                            <span className="value">
                                £
                                {leadomatic.original_advert_price || '-'}
                            </span>
                        </p>
                        <p>
                            <span>Latest Price:</span>
                            <span className="value">
                                £
                                {leadomatic.latest_advert_price || '-'}
                            </span>
                        </p>
                        <p>
                            <span>Phone:</span>
                            <span className="value">{leadomatic.advert_phone || '-'}</span>
                        </p>
                        <p>
                            <span>Source:</span>
                            <span className="value">{leadomatic.source || '-'}</span>
                        </p>
                        <p>
                            <span>Reference:</span>
                            <Button type="primary" size="small" style={{ fontSize: 10 }}>
                                <a href={leadomatic.advert_url} target="_blank">View Advert</a>
                            </Button>
                        </p>
                    </Col>
                )
                : null
        );
    }
});



// WEBPACK FOOTER //
// ./src/modules/Leads/Lead_profile/components/Lead_profile_table/LeadomaticInfo.js